import { FC } from 'react';
import { useFetcher, useLocation } from 'react-router-dom';
import { AttachFile, Download } from '@mui/icons-material';
import { Box, Typography, useTheme, IconButton } from '@mui/material';
import { UploadedFileStatus } from 'src/types';
import { OrderAction } from 'src/types/loaders';

export interface SlideImageDownloadRowProps {
  fileId: string;
  filename: string;
  status?: UploadedFileStatus | null;
  showDownloadButton?: boolean;
}

export const SlideImageDownloadRow: FC<SlideImageDownloadRowProps> = ({
  fileId,
  filename,
  status,
  showDownloadButton = true,
}) => {
  const theme = useTheme();
  const fetcher = useFetcher();
  const location = useLocation();

  const handleDownloadSlideImage = () => {
    const formData = new FormData();
    formData.append('action', OrderAction.DOWNLOAD_SLIDE_IMAGE);
    formData.append('fileId', fileId);
    fetcher.submit(formData, {
      method: 'post',
      action: location.pathname,
    });
  };

  return (
    <Box>
      <Typography
        variant='subtitle1'
        sx={{
          fontWeight: theme.typography.fontWeightMedium,
          mb: 1,
        }}
      >
        Slide Image:
      </Typography>
      <Box
        sx={{
          p: 1,
          border: 1,
          mb: 1,
          borderRadius: 1,
          backgroundColor: theme.palette.background.default,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <AttachFile
            sx={{
              color: theme.palette.text.secondary,
              fontSize: '24px',
            }}
          />
          <Typography
            variant='body2'
            sx={{
              flex: 1,
            }}
          >
            {filename}
          </Typography>
          {status === UploadedFileStatus.InProgress && (
            <Typography variant='caption' color='textSecondary'>
              Uploading...
            </Typography>
          )}
          {status === UploadedFileStatus.Complete && showDownloadButton && (
            <IconButton
              aria-label='Download slide image'
              onClick={handleDownloadSlideImage}
            >
              <Download />
            </IconButton>
          )}
        </Box>
      </Box>
    </Box>
  );
};
